import { render, staticRenderFns } from "./spareGetDetailNew.vue?vue&type=template&id=621e947c"
import script from "./spareGetDetailNew.vue?vue&type=script&lang=js"
export * from "./spareGetDetailNew.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetailNew.vue?vue&type=style&index=0&id=621e947c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports